// App.js
import React, { useState, useEffect } from 'react';
import OutlinedTimeline from './components/Timeline';
import MenuBar from './components/MenuBar';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'; 
import './App.css';
import Trav from './pages/TravisScott'; 
import O from './pages/OliviaRodrigo'; 
import Cold from './pages/ColdPlay'; 
import Stray from './pages/StrayKids'; 

import Privacy from './pages/Privacy'; 

import { initializeApp } from 'firebase/app'; 
import { getAnalytics } from 'firebase/analytics'; 

const firebaseConfig = {
  apiKey: "AIzaSyBgwKyoPXuqxh4UQKpq7QWFMZwVKBSO6aQ",
  authDomain: "ozconcert.firebaseapp.com",
  projectId: "ozconcert",
  storageBucket: "ozconcert.appspot.com",
  messagingSenderId: "687489864396",
  appId: "1:687489864396:web:9884e814f87c7d5edea869",
  measurementId: "G-SCZ4HZPHZG"
};

const app = initializeApp(firebaseConfig); 
const analytics = getAnalytics(app); 
console.log(analytics); 


const App = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const events = [
    'Olivia Rodrigo', 
    'Travis Scott',
    'Stray Kids',  
    'Coldplay',
  ];

  return (
    <Router>
      <div className="app-container">
        {isMobile ? <MenuBar /> : <OutlinedTimeline events={events} fillPercentage={0.45} />}
        <div className="page-content">
          <Routes>
            <Route path="/travis-scott" element={<Trav />} />
            <Route path="/olivia-rodrigo" element={<O />} />
            <Route path="/coldplay" element={<Cold />} />
            <Route path="/stray-kids" element={<Stray />} />
            <Route path='/privacy' element={<Privacy />} />
            <Route path="/" element={<Navigate to="/travis-scott" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
